import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m9m8u7ancn: FaireBrandEntity = {
  token: "b_m9m8u7ancn",
  type: "brand",
  name: "HalalEveryDay",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f5a44eb5714dab710d439b5807c64eac29c1e39c0fba3617903375b9510e8d2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f45ba723cd9f808e0fd8482f95d17135aaf69cf9b5e96a8cbfa1f7b18b341a60.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2f5a44eb5714dab710d439b5807c64eac29c1e39c0fba3617903375b9510e8d2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f45ba723cd9f808e0fd8482f95d17135aaf69cf9b5e96a8cbfa1f7b18b341a60.png",
  location: "Bethpage, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 13,
  isInsider: true,
  description:
    "HalalEveryday was created because we believe that the best cures are found in nature. We wanted to source the best natural products to take care of our bodies both inside and out, and then offer them at affordale prices for our customers. Our products are ethically sourced, locally and globally, and we research and test each and every one before offering them in our store. Our mission is to be honest, fair, humble and responsible each and every day that we provide these products to our customers. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:11.422Z",
    importedBy: "entity-db-cli",
  },
};
